<template lang="pug">
  #WithdrawalSizeCountCards
    b-row(cols="1" cols-sm="3" cols-md="4" cols-lg="6")
      b-col.mb-2(v-for="counter in visibleCounters" :key="counter.size")
        status-summary-card(
          :stateName="counter.label"
          :color="counter.color"
          :mainValue="counter.count"
          unit=""
          :subLabel="`${counter.percentage}%`"
          inline-sub-label
        )
    .text-center.mt-1(v-if="isCollapsible")
      app-text-button(
        :icon="expanded ? 'chevron-up' : 'chevron-down'"
        :label="expanded ? 'Contraer' : 'Expandir'"
        @click="expanded = !expanded"
      )
</template>

<script>
import StatusSummaryCard from '../UI/StatusSummaryCard'
import AppTextButton from '../UI/AppTextButton'
import { mapActions } from 'vuex'

export default {
  name: 'WithdrawalSizeCountCards',
  components: {
    StatusSummaryCard,
    AppTextButton
  },
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    refreshKey: {
      type: Number,
      default: 0
    },
    maxColumns: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      counts: {},
      flexCounts: { medium: 0, small: 0 },
      customServices: [],
      totalPackages: 0,
      expanded: false,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 0
    }
  },
  watch: {
    refreshKey() {
      this.fetchSizeCounts()
    }
  },
  created() {
    this.fetchSizeCounts()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    totalCount() {
      return this.totalPackages || 0
    },
    columnsPerRow() {
      const width = this.viewportWidth
      if (width < 576) return 1
      if (width < 768) return 3
      if (width < 992) return 4
      return 6
    },
    totalRows() {
      return Math.ceil(this.sizeCounters.length / this.columnsPerRow)
    },
    isCollapsible() {
      return this.totalRows > 2
    },
    visibleCounters() {
      if (this.expanded || !this.isCollapsible) return this.sizeCounters
      return this.sizeCounters.slice(0, this.columnsPerRow * 2)
    },
    sizeCounters() {
      const fixedSizes = [
        { size: 'small', label: 'Same Day Pequeño', color: 'var(--status-in-transit)' },
        { size: 'medium', label: 'Same Day Mediano', color: 'var(--status-approved)' }
      ]

      const cards = fixedSizes.map(f => ({
        ...f,
        count: this.counts[f.size] || 0
      }))

      cards.push({
        size: 'flex-medium',
        label: 'Flex Mediano',
        color: 'var(--status-rejected)',
        count: this.flexCounts.medium || 0
      })

      cards.push({
        size: 'flex-small',
        label: 'Flex Pequeño',
        color: 'var(--status-rejected)',
        count: this.flexCounts.small || 0
      })

      const customServices = this.customServices
        .map(s => ({
          size: s.name,
          label: s.name,
          color: 'var(--status-partial)',
          count: this.counts[s.name] || 0
        }))
      const seenCustomSizes = new Set(customServices.map(c => c.size))
      Object.keys(this.counts).forEach(s => {
        if (s !== 'small' && s !== 'medium' && !seenCustomSizes.has(s)) {
          customServices.push({
            size: s,
            label: s,
            color: 'var(--status-partial)',
            count: this.counts[s]
          })
        }
      })

      cards.push(...customServices)

      return cards.map(card => ({
        ...card,
        percentage: this.percentageOf(card.count)
      }))
    }
  },
  methods: {
    ...mapActions(['getWithdrawalSizeCounts']),
    handleResize() {
      this.viewportWidth = window.innerWidth
    },
    percentageOf(count) {
      if (!this.totalCount) return 0
      return Math.round((count / this.totalCount) * 1000) / 10
    },
    async fetchSizeCounts() {
      const response = await this.getWithdrawalSizeCounts({ params: { ...this.filters } })
      if (response.ok) {
        this.counts = response.data.counts || {}
        this.flexCounts = response.data.flexCounts || { medium: 0, small: 0 }
        this.customServices = response.data.customServices || []
        this.totalPackages = response.data.totalPackages || 0
      }
    }
  }
}
</script>